import React, { useCallback, useMemo } from 'react'
import { useFormik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'

import EditForm from '../../../../../../features/components/Forms/EditForm'
import Field from '../../../../../../components/Form/Field'

import { usePurifiedFormik } from '../../../../../../hooks/formHooks/usePurifiedFormik'
import { useEditSectionFormSubmit } from '../../../../../../hooks/formHooks/useEditSectionFormSubmit'

import { updateAd } from '../../../../../../modules/actions/ads'
import { selectedDV360AdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import { getInitialValues, validationSchema } from './fields'
import { CLICK_THROUGH_LINK, formatAdLink } from '../../../fields'
import { DV_360_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import { HISTORY_META_EDIT_SECTION } from '../../../../../../constants/changeHistory'

const LinkSectionForm = ({ editItemData: ad, successSubmit, isInternalAd, title, ...formProps }) => {
  const dispatch = useDispatch()

  const { id: selectedAdAccountId } = useSelector(selectedDV360AdAccountSelector)

  const { id, account: adAccountId } = ad
  const adAccount = adAccountId || selectedAdAccountId

  const initialValues = useMemo(() => getInitialValues(ad), [ad])

  const handleSubmit = useCallback(
    values => {
      dispatch(
        updateAd(
          {
            account: adAccount,
            exit_events: formatAdLink(values[CLICK_THROUGH_LINK]),
            ...(isInternalAd && { internal: true }),
            meta: {
              [HISTORY_META_EDIT_SECTION]: title
            }
          },
          id,
          DV_360_PLATFORM
        )
      )
    },
    [dispatch, id, isInternalAd, adAccount, title]
  )

  const { onSubmit, manualSuccessSubmit } = useEditSectionFormSubmit({ initialValues, handleSubmit })

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    enableReinitialize: true
  })

  const purifiedFormik = usePurifiedFormik(formik)

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      successSubmit={successSubmit || manualSuccessSubmit}
      {...formProps}
    >
      <Field formik={formik} name={CLICK_THROUGH_LINK} placeholder="Click Through Link" autoComplete="off" />
    </EditForm>
  )
}

export default LinkSectionForm
